const FlatCardHeader = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col space-y-1.5 py-2">{children}</div>
}

export default FlatCardHeader
